const namespace = 'bravissimo/unsubscribe';

export const RECEIVE_EMAIL = `${namespace}/RECEIVE_EMAIL`;
export const RECEIVE_REASONS = `${namespace}/RECEIVE_REASONS`;
export const RECEIVE_SOURCE = `${namespace}/RECEIVE_SOURCE`;
export const UNSUBSCRIBE = `${namespace}/UNSUBSCRIBE`;
export const UNSUBSCRIBE_SUCCESS = `${namespace}/UNSUBSCRIBE_SUCCESS`;
export const UNSUBSCRIBE_FAILURE = `${namespace}/UNSUBSCRIBE_FAILURE`;
